import { render, staticRenderFns } from "./academic_examination_fengtalk.vue?vue&type=template&id=7641bd09&scoped=true&"
import script from "./academic_examination_fengtalk.vue?vue&type=script&lang=js&"
export * from "./academic_examination_fengtalk.vue?vue&type=script&lang=js&"
import style0 from "./academic_examination_fengtalk.vue?vue&type=style&index=0&id=7641bd09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641bd09",
  null
  
)

export default component.exports